import { render, staticRenderFns } from "./ListWithInfo.vue?vue&type=template&id=1b0bd1af&scoped=true&"
import script from "./ListWithInfo.vue?vue&type=script&lang=js&"
export * from "./ListWithInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0bd1af",
  null
  
)

export default component.exports